import {isLoaded} from 'Core/models/Async';
import {Map as IMap} from 'immutable';
import {updateQuoteFormErrors} from 'Quoting/ducks/createQuote';
import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {runProductValidations} from 'Quoting/utils/validation';

type MinMaxValidationResult = {
  handleValidation: Function;
};

export const useFormValidation = (formFieldId: string): MinMaxValidationResult => {
  const {minMaxConfig, quote} = useSelector((state: ReducerState) => state.quoteForm);

  const dispatch = useDispatch();

  const handleValidation = useCallback(() => {
    if (formFieldId) {
      const quoteData: IMap<string, any> | undefined = isLoaded(quote) ? quote?.Data : undefined;

      const validationErrors = runProductValidations(quoteData, quoteData?.get('_modelName'), minMaxConfig);

      dispatch(updateQuoteFormErrors(validationErrors));
    }
  }, [quote, minMaxConfig]);

  return {
    handleValidation,
  };
};
